export const numCommas = (num) => {
  return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatMoney = (amount, c = 2, d = '.', t = ',') => {
  const n = Math.abs(Number(amount) || 0);
  const s = amount < 0 ? '-' : '';
  const fixed = n.toFixed(c);
  const [intPart, decPart] = fixed.split('.');
  const i = intPart.length;
  const j = i > 3 ? i % 3 : 0;

  return (
    s +
    (j ? intPart.substring(0, j) + t : '') +
    intPart.substring(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
    (c ? d + decPart : '')
  );
}